import 'raygun4js';
import LHX from 'utils/LHX';

 // raygun4js creates a global instance of Raygun on the window
const Raygun = window.Raygun;

/* eslint-disable */
const internetExplorerJscriptVersion = new Function('/*@cc_on return @_jscript_version; @*/')();
/*eslint-enable */
const isUnsupportedJscriptVersion = typeof internetExplorerJscriptVersion !== 'undefined' && Number(internetExplorerJscriptVersion) < 11;

const isRaygunEnabled = () => !isUnsupportedJscriptVersion && (LHX.environment === 'prod' || LHX.environment === 'staging');
const raygunAPIKey = LHX.environment === 'prod' ? 'AEjFXx0CivlITWTWI3wxKQ==' : 'WDHeyKeMiYXIyQsgXr01Pg==';
const raygunOptions = {
  ignoreAjaxAbort: true,
  ignore3rdPartyErrors: true,
};

if (isRaygunEnabled()) {
  Raygun.init(raygunAPIKey, raygunOptions)
    .attach()
    .setVersion(LHX.version)
    .saveIfOffline(true);
}

/* eslint-disable */
if (__DEBUG__ && isUnsupportedJscriptVersion) {
  const logMethod = console.warn ? 'warn' : 'log';
  console[logMethod]('WARNING! Raygun error reporting is disabled for this browser');
}
/*eslint-enable */

export default {
  sendError(error) {
    if (isRaygunEnabled()) {
      Raygun.send(error);
    }
  },
};



/** WEBPACK FOOTER **
 ** ./src/utils/monitoring.js
 **/